<template>
  <div class="app-container crm-detail">
    <el-card class="crm-detail-base" shadow="never">
      <el-row>
        <el-col :span="16">
          <span class="base-name">{{detail.customerName}}</span>
          <CompanyInfoButton v-model="detail.companyId" :companyName="detail.customerName"></CompanyInfoButton>
        </el-col>
        <el-col :span="8" v-if="detail.id" align="right">
          <el-button type="text" v-if="!detail.focusFlag" @click="handleFocus(1)">关注</el-button>
          <el-button type="text" v-if="detail.focusFlag" @click="handleFocus(2)">取消关注</el-button>
          <el-button type="text" v-if="detail.canChangeStatus && detail.status === 0" @click="updateCustomerStatus(1)">设为失效</el-button>
          <el-button type="text" v-if="detail.canChangeStatus && detail.status === 1" @click="updateCustomerStatus(0)">恢复</el-button>
          <el-button type="text" v-if="detail.canAssignFlag" @click="handleAssign()">分配</el-button>
        </el-col>
      </el-row>
      <div>
        <div class="base-item">
          <div class="title label">客户编号</div>
          <div class="value">{{detail.customerNum}}</div>
        </div>
        <div class="base-item">
          <div class="title label">客户性质</div>
          <div class="value">{{detail.customerNatureDesc}}</div>
        </div>
        <div class="base-item">
          <div class="title label">客户类型</div>
          <div class="value">{{detail.customerTypeDesc}}</div>
        </div>
        <div class="base-item">
          <div class="title label">客户来源</div>
          <div class="value">{{detail.customerSourceDesc}}</div>
        </div>
        <div class="base-item">
          <div class="title label">客户级别</div>
          <div class="value">{{detail.customerLevelDesc}}</div>
        </div>
        <div class="base-item">
          <div class="title label">客户状态</div>
          <div class="value">{{detail.statusDesc}}</div>
        </div>
        <div class="base-item">
          <div class="title label">未跟进天数</div>
          <div class="value">{{detail.lastFollowIntervalDay || detail.lastFollowIntervalDay===0 ? detail.lastFollowIntervalDay + "天" : ""}}</div>
        </div>
        <div class="base-item">
          <div class="title label">最新跟进时间</div>
          <div class="value">{{detail.lastFollowInfo ? detail.lastFollowInfo.createTime : ""}}</div>
        </div>
      </div>
    </el-card>
    <el-row :gutter="16">
      <el-col :span="16">
        <el-card class="crm-detail-main" v-if="detail.id" shadow="never">
          <el-tabs v-model="activeName" @tab-click="handleTabClick" :stretch="true">
            <el-tab-pane v-if="canViewCustomerAnalysis" label="经营分析" name="analysis" lazy>
              <CustomerAnalysisPanel ref="customerAnalysisRef" :customer-id="detail.id"/>
            </el-tab-pane>
            <el-tab-pane label="跟进计划" name="followPlan">
              <el-tabs v-model="followPlanActiveName" :stretch="true">
                <el-tab-pane label="跟进记录" name="follow">
                  <FollowAdd ref="followAddRef" :targetId="detail.id" targetType="customer" @success="handleAfterFollowAdd"></FollowAdd>
                  <div style="text-align:right;margin-bottom:10px;margin-right:15px;">
                    <el-select v-model="targetTypeFilter" placeholder="请选择" clearable>
                      <el-option
                        v-for="item in targetTypeOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                  <div style="height: 473px">
                    <FollowList :targetId="detail.id" targetType="customer" :targetTypeFilter="targetTypeFilter" ref="followListRef"></FollowList>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="工作计划" name="workPlan">
                  <WorkPlan ref="workPlanRef" :targetId="detail.id" targetType="customer" :managerId="!detail.manager ? null : detail.manager.managerId" @success="handleAfterWorkPlanAdd"></WorkPlan>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
            <el-tab-pane label="详细资料" name="detail">
              <el-row>
                <el-col align="right" style="height: 40px;">
                  <el-button type="text" @click="handleEdit" v-if="!editModel && detail.updateAuth" :disabled="!detail.id">编辑资料</el-button>
                  <el-button type="primary" @click="handleEditSave" v-if="editModel">保存</el-button>
                  <el-button  @click="editModel=false" v-if="editModel">取消</el-button>
                </el-col>
              </el-row>
              <el-form :model="updateData" :rules="updateRules" ref="updateForm" label-width="90px" :hide-required-asterisk="!editModel">
                <el-row :gutter="20" align="left">
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="客户编号:" prop="customerNum">
                      <span class="value">{{ detail.customerNum }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="客户性质:" prop="customerNature">
                      <el-select v-if="editModel" v-model="updateData.customerNature" placeholder="请选择客户类型" clearable
                                 style="width:100%">
                        <el-option v-for="dict in natureOptions" :key="dict.dictValue" :label="dict.dictLabel"
                                   :value="dict.dictValue"/>
                      </el-select>
                      <span v-else class="value">{{ detail.customerNatureDesc }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="客户类型:" prop="customerType">
                      <el-select v-if="editModel" v-model="updateData.customerType" placeholder="请选择客户类型" clearable
                                 style="width:100%">
                        <el-option v-for="dict in customerTypeOptions" :key="dict.dictValue" :label="dict.dictLabel"
                                   :value="dict.dictValue"/>
                      </el-select>
                      <span v-else class="value">{{ detail.customerTypeDesc }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="客户名称:" prop="customerName">
                      <CompanyInput v-if="editModel" v-model="updateData.customerName" :companyId="updateData.companyId"
                                    @change="handleCompanyChange"/>
                      <span v-else class="value">{{ detail.customerName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="客户来源:" prop="source">
                      <el-select v-if="editModel" v-model="updateData.source" placeholder="请选择客户来源" allow-create
                                 filterable clearable style="width:100%">
                        <el-option v-for="dict in sourceOptions" :key="dict.dictValue" :label="dict.dictLabel"
                                   :value="dict.dictValue"/>
                      </el-select>
                      <span v-else class="value">{{ detail.customerSourceDesc }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="客户级别:" prop="customerLevel">
                      <el-select v-if="editModel" v-model="updateData.customerLevel" placeholder="请选择客户级别" clearable
                                 style="width:100%">
                        <el-option v-for="dict in customerLevelOptions" :key="dict.dictValue" :label="dict.dictLabel"
                                   :value="dict.dictValue"/>
                      </el-select>
                      <span v-else class="value">{{ detail.customerLevelDesc }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="所在区域:" prop="area">
                      <el-cascader v-if="editModel" v-model="updateData.area" :options="areaOptions"
                                   :props="{ checkStrictly: true }" filterable clearable
                                   style="width:100%"></el-cascader>
                      <span v-else class="value">{{ detail.provinceName }}{{ detail.cityName }}{{ detail.regionName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="详细地址:" prop="address">
                      <el-input v-if="editModel" v-model="updateData.address" :maxlength="64" placeholder="请输入详细地址"
                                clearable/>
                      <span v-else class="value">{{ detail.address }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item :label="customerWebsite.label + ':'" prop="url" class="customer-website-field">
                      <el-input v-if="editModel" v-model="updateData.url" :maxlength="255" :placeholder="'请输入' + customerWebsite.label"
                                clearable/>
                      <el-tooltip v-else-if="customerWebsite.href" effect="dark" popper-class="customer-link-tooltip"
                                  :content="customerWebsite.value" placement="top">
                        <el-link type="primary" :underline="false" :href="customerWebsite.href"
                                 target="_blank" rel="noopener noreferrer">{{ customerWebsite.text }} <i class="el-icon-top-right" />
                        </el-link>
                      </el-tooltip>
                      <span v-else class="value">{{ customerWebsite.value || '-' }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12" v-if="!editModel">
                    <el-form-item label="创建人:">
                      <span class="value">{{ detail.createUserName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12" v-if="!editModel">
                    <el-form-item label="创建时间:">
                      <span class="value">{{ detail.createTime }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item label="备注:" prop="remark">
                      <el-input
                        v-if="editModel"
                        type="textarea"
                        :autosize="{ minRows: 3, maxRows: 5}"
                        :maxlength="1000"
                        show-word-limit
                        v-model="updateData.remark"
                        placeholder="请输入备注"
                        clearable/>
                      <span v-else class="value">{{ detail.remark }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </el-tab-pane>
            <el-tab-pane :label="'联系人(' + contactCount + ')'" name="contact">
              <CustomerContactList ref="customerContactListRef" :customerId="detail.id" :param-data="detail" height="630" @after-query="handleAfterContactQuery"></CustomerContactList>
            </el-tab-pane>
            <el-tab-pane :label="'商机(' + businessCount + ')'" name="business">
              <BusinessList ref="businessListRef" :customerId="detail.id" :param-data="detail" height="630" @after-query="handleAfterBusinessQuery"></BusinessList>
            </el-tab-pane>
            <el-tab-pane :label="'合同(' + contractCount + ')'" name="contract">
              <ContractList ref="contractListRef" :customerId="detail.id" :customerName="detail.customerName" height="630" @after-query="handleAfterContractQuery">
              </ContractList>
            </el-tab-pane>
            <el-tab-pane :label="'交付(' + deliverCount + ')'" name="deliver">
              <deliverList ref="deliverListRef" :customerId="detail.id" :customerName="detail.customerName" type="customer" height="630" @after-query="handleAfterDeliverQuery">
              </deliverList>
            </el-tab-pane>
            <el-tab-pane :label="'服务(' + serviceCount + ')'" name="service">
              <ServiceList ref="serviceListRef" :customerId="detail.id" @after-query="handleAfterServiceQuery"/>
            </el-tab-pane>
            <el-tab-pane :label="'回款管理'" name="contractInfo">
              <ContractInfo ref="contractInfoRef" :customerId="detail.id" height="630"></ContractInfo>
            </el-tab-pane>
            <!-- <el-tab-pane :label="'回款计划(' + contractPlanFundCount + ')'" name="contractPlanFund">
              <PlanFundList ref="planFundListRef" :customerId="detail.id" height="630" @after-query="handleAfterPlanFundQuery"></PlanFundList>
            </el-tab-pane>
            <el-tab-pane :label="'回款记录(' + contractFundRecordCount + ')'" name="contractFundRecord">
              <FundRecordList ref="fundRecordListRef" :customerId="detail.id" height="630" @after-query="handleAfterFundRecordQuery"></FundRecordList>
            </el-tab-pane> -->
            <el-tab-pane :label="'开票记录(' + contractInvoiceCount + ')'" name="contractInvoice">
              <InvoiceList ref="invoiceListRef" :customerId="detail.id" height="630" @after-query="handleAfterInvoiceQuery"></InvoiceList>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="crm-detail-follow" v-if="detail.id" shadow="never">
          <div class="label">负责人</div>
          <div class="crm-manager">
            <UserAvatar class="avatar" :url="detail.manager ? detail.manager.managerAvatar : ''" :name="detail.manager ? detail.manager.managerName : ''"/>
            <div class="name"><span class="value">{{detail.manager ? detail.manager.managerName : ""}}</span></div>
          </div>
          <GroupMember :groupName="'客户团队'" :targetId="detail.id" :targetType="'customer'"
                       :canAddGroupMemberFlag="detail.canAddGroupMemberFlag" @success="handleGroupMemberSuccess"/>
          <el-divider content-position="left"><span class="label">操作日志</span></el-divider>
          <div style="height: 534px">
            <OperateLogList ref="operateLogListRef" :targetId="detail.id" targetType="customer"></OperateLogList>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <AssignDialog ref="assignDialogRef" @success="refreshDetailAndLog"></AssignDialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { transferCascaderOptionsForProvince} from '@/utils/index'
import UserSelect from "@/views/crm/components/userSelect";
import ServiceList from "@/views/crm/service/serviceList";
import DeliverList from "@/views/crm/delivery/deliverList";
import FollowList from "@/views/crm/follow/followList";
import FollowAdd from "@/views/crm/follow/followAdd";
import WorkPlan from "@/views/crm/workPlan/workPlan";
import OperateLogList from "@/views/crm/components/operateLogList";
import CompanyInfoButton from "@/views/crm/components/companyInfoButton";
import CompanyInput from "@/views/crm/components/companyInput";
import AssignDialog from "@/views/crm/components/assignDialog";
import BusinessList from "@/views/crm/business/businessList";
import CustomerContactList from "@/views/crm/customer/customerContactList";
import ContractList from "@/views/crm/contract/contractList";
import ContractInfo from "@/views/crm/planFund/contractInfo"
import InvoiceList from "@/views/crm/invoice/invoiceList";
import {listAllLevelArea} from "@/api/crm/area";
import {queryCustomerDetail, queryCustomerByName, updateCustomer, updateCustomerStatus} from "@/api/crm/customer";
import UserAvatar from '@/views/system/user/userAvatar'
import {changeStatus} from "@/api/crm/focus";
import GroupMember from "@/views/crm/groupMember"
import CustomerAnalysisPanel from "@/views/crm/customerAnalysis/components/CustomerAnalysisPanel"
import {checkPermi} from "@/utils/permission"
import { customerLink } from '@/utils/customerLink'

export default {
  name: "CustomerDetail",
  data() {
    return {
      // 遮罩层
      loading: true,
      targetTypeFilter: '', // 分类查询
      detail: {},
      activeName: "followPlan",
      followPlanActiveName: 'follow',
      editModel: false,
      sourceOptions: [],
      customerLevelOptions: [],
      customerTypeOptions: [],
      professionOptions: [],
      natureOptions: [],
      areaOptions: [],
      contactCount: 0,
      businessCount: 0,
      deliverCount: 0,
      contractCount: 0,
      serviceCount: 0,
      contractPlanFundCount: 0,
      contractFundRecordCount: 0,
      contractInvoiceCount: 0,
      updateData: {
        id: null,
        companyId: null,
        customerName: null,
        customerNature: null,
        customerType: null,
        source: null,
        customerLevel: null,
        profession: null,
        area: [],
        address: null,
        url: null,
        employeeNo: undefined,
        remark: null
      },
      updateRules: {
        customerType:[
          {required: true, message: '请选择客户类型', trigger: 'change'}
        ],
        customerName: [
          {required: true, validator: this.checkCustomerName}
        ],
        source: [
          {required: true, message: '请选择客户来源', trigger: 'change'}
        ],
        customerLevel: [
          {required: true, message: '请选择客户级别', trigger: 'change'}
        ],
        managerId: [
          {required: true, type: 'number', message: '请选择负责人', trigger: 'change'}
        ]
      },
      targetTypeOptions: [{
        label: '联系人',
        value: 'contact'
      },{
        label: '客户',
        value: 'customer'
      },{
        label: '线索',
        value: 'clue'
      },{
        label: '商机',
        value: 'business'
      },{
        label: '合同',
        value: 'contract'
      },{
        label: '交付',
        value: 'deliveryOrder'
      },{
        label: '服务',
        value: 'serviceOrder'
      },]
    };
  },
  components: {
    UserSelect,
    FollowList,
    FollowAdd,
    WorkPlan,
    OperateLogList,
    CompanyInfoButton,
    CompanyInput,
    AssignDialog,
    BusinessList,
    CustomerContactList,
    ContractList,
    ContractInfo,
    ServiceList,
    DeliverList,
    // PlanFundList,
    // FundRecordList,
    InvoiceList,
    UserAvatar,
    GroupMember,
    CustomerAnalysisPanel
  },
  created() {
    if (this.$route.params.id) {
      this.queryDetail()
    } else {
      this.msgError("无效的线索");
    }
    this.getDicts("common_source").then(response => {
      this.sourceOptions = response.data;
    });
    this.getDicts("sys_customer_level").then(response => {
      this.customerLevelOptions = response.data;
    });
    this.getDicts("sys_customer_type").then(response => {
      this.customerTypeOptions = response.data;
    });
    this.getDicts("customer_nature").then(response => {
      this.natureOptions = response.data;
    });
    this.getDicts("profession").then(response => {
      this.professionOptions = response.data;
    });
    listAllLevelArea({ level: 3 }).then(response => {
      this.areaOptions = transferCascaderOptionsForProvince(response.data);
    });
  },
  computed: {
    customerWebsite () { return customerLink(this.detail) },
    canViewCustomerAnalysis () {
      const permissions = this.$store.getters.permissions || []
      return permissions.includes('*:*:*') || checkPermi([
        'crm:customerAnalysis:manage',
        'crm:customerAnalysis:list',
        'crm:customer:manage'
      ])
    },
    contractInfoCount () {
      return this.contractPlanFundCount + this.contractFundRecordCount
    },
    ...mapState({
      currentUserId: state => state.user.userId,
    })
  },
  watch: {
    editModel (val) {
      if (!val) {
        this.resetForm("updateForm");
      }
    }
  },
  methods: {
    handleTabClick (tab) {
      if (tab.name === 'analysis') {
        this.$refs.customerAnalysisRef && this.$refs.customerAnalysisRef.refresh()
      } else if (tab.name === 'contact') {
        this.$refs.customerContactListRef.queryList()
      } else if (tab.name === 'business') {
        this.$refs.businessListRef.queryList()
      } else if (tab.name === 'contract') {
        this.$refs.contractListRef.queryList()
      // } else if (tab.name === 'contractPlanFund') {
      //   this.$refs.planFundListRef.queryList()
      // } else if (tab.name === 'contractFundRecord') {
      //   this.$refs.fundRecordListRef.queryList()
      } else if (tab.name === 'contractInvoice') {
        this.$refs.invoiceListRef.queryList()
      } else if (tab.name === 'contractInfo') {
        this.$refs.contractInfoRef.queryList()
      } else if (tab.name === 'service') {
        this.$refs.serviceListRef.queryList()
      } else if (tab.name === 'deliver') {
        this.$refs.deliverListRef.queryList()
      }
    },
    refreshDetailAndLog() {
      this.queryDetail();
      this.refreshOperateLogList();
    },
    queryDetail () {
      queryCustomerDetail({id:this.$route.params.id}).then(response => {
        if (response.data) {
          this.detail = response.data
        } else {
          this.msgError("查询不到此客户");
        }
      }).catch(error => {
        this.detail = {}
      })
    },
    handleGroupMemberSuccess(userId) {
      if (this.currentUserId === userId) {
        this.queryDetail()
      }
      this.refreshOperateLogList()
      if (this.$refs.followAddRef) {
        this.$refs.followAddRef.queryAtList()
        this.$refs.workPlanRef.queryAtList()
      }
    },
    handleCompanyChange(companyName, companyId) {
      this.updateData.companyId = companyId ? companyId : ''
    },
    checkCustomerName (rule, value, callback) {
      if (!value) {
        callback(new Error("请输入客户名称"))
      } else if (value === this.detail.customerName) {
        callback()
      } else {
        queryCustomerByName(
          {
            customerName: value
          }
        ).then( response => {
          if (response.data && response.data.id) {
            var statusStr=response.data.status==0?'有效':'失效';
            callback("客户名称已存在，状态为"+statusStr+"，请重新输入")
          } else {
            callback()
          }
        }).catch(error => {
          callback()
        })
      }
    },
    handleAfterFollowAdd () {
      this.$refs.followListRef.refresh()
      this.queryDetail()
    },
    refreshOperateLogList () {
      this.$refs.operateLogListRef.refresh()
    },
    handleAfterContactQuery (contactList) {
      this.contactCount = contactList.length;
    },
    handleAfterBusinessQuery (businessList) {
      this.businessCount = businessList.length;
    },
    handleAfterContractQuery (contactList) {
      this.contractCount = contactList.length;
    },
    handleAfterPlanFundQuery (list) {
      this.contractPlanFundCount = Number(list.length);
    },
    handleAfterServiceQuery (serviceList) {
      this.serviceCount = serviceList.length;
    },
    handleAfterDeliverQuery (deliverList) {
      this.deliverCount = deliverList.length
    },
    handleAfterFundRecordQuery (list) {
      this.contractFundRecordCount = Number(list.length);
    },
    handleAfterInvoiceQuery (list) {
      this.contractInvoiceCount = list.length;
    },
    handleEdit () {
      const {id, companyId, customerName, customerNature, customerType, source, customerLevel, profession, area, address, url, employeeNo, remark, provinceCode, cityCode, regionCode} = this.detail
      this.updateData.id = id;
      this.updateData.companyId = companyId;
      this.updateData.customerName = customerName;
      this.updateData.customerNature = customerNature
      this.updateData.customerType = customerType;
      this.updateData.source = source;
      this.updateData.customerLevel = customerLevel;
      this.updateData.profession = profession;
      this.updateData.area = area;
      this.updateData.address = address;
      this.updateData.url = url;
      this.updateData.employeeNo = employeeNo || undefined;
      this.updateData.remark = remark;
      let areaTemp = []
      provinceCode && areaTemp.push(provinceCode)
      cityCode && areaTemp.push(cityCode)
      regionCode && areaTemp.push(regionCode)
      this.updateData.area = areaTemp
      this.editModel = true
    },
    handleEditSave () {
      this.$refs['updateForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          this.updateData.provinceCode = this.updateData.area && this.updateData.area.length > 0 ? this.updateData.area[0] : null
          this.updateData.cityCode = this.updateData.area && this.updateData.area.length > 1 ? this.updateData.area[1] : null
          this.updateData.regionCode = this.updateData.area && this.updateData.area.length > 2 ? this.updateData.area[2] : null
          updateCustomer(this.updateData).then(response => {
            this.refreshDetailAndLog();
            this.editModel = false
            loading.close();
            this.msgSuccess("更新成功");
          }).catch(error => {
            loading.close()
          })
        }
      });
    },
    /** 分配按钮操作 */
    handleAssign() {
      this.$refs.assignDialogRef.singleAssign("customer", this.detail.id)
    },
    handleFocus (operateType) {
      let param = {
        targetId: this.detail.id,
        targetType: 'customer',
        operateType: operateType // 操作类型 1-关注 2-取消关注
      }
      const loading = this.$loading({lock: true, text: '操作中', spinner: 'el-icon-loading'});
      changeStatus(param).then(response => {
          this.msgSuccess(operateType === 1 ? '关注成功' : '取消关注成功')
          this.queryDetail()
        }
      ).finally(() => {
        loading.close();
      });
    },
    handleAfterWorkPlanAdd () {
      this.refreshOperateLogList();
      this.$refs["followListRef"].refresh()
    },
    updateCustomerStatus(targetStatus) {
      let msg = ''
      if (targetStatus === 1) {
        msg = '确认将该客户设为失效吗？';
      } else {
        msg = '确认将该客户恢复为有效吗？';
      }
      this.$confirm(msg, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({lock: true, text: '操作中', spinner: 'el-icon-loading'});
        updateCustomerStatus({
          id: this.detail.id,
          status: targetStatus
        }).then(response => {
          this.msgSuccess("操作成功");
          this.refreshDetailAndLog()
        }).finally(error => {
          loading.close()
        })
      })
    }
  }
};
</script>

<style scoped>
.customer-website-field { min-width: 0; }
.customer-website-field .value { overflow-wrap: anywhere; word-break: break-all; }
.customer-website-field .el-link { max-width: 100%; line-height: 1.5; }
</style>
<style>
.customer-link-tooltip { max-width: min(480px, 85vw); overflow-wrap: anywhere; word-break: break-all; }
</style>
